export default __webpack_public_path__ + "static/media/contract_4.710e3632.jpg";